import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Checkbox from '../components/global/checkbox.js'
import Slider, { Range } from 'rc-slider'
import 'rc-slider/assets/index.css'

let initialValues
let marks
let lastMark
let firstMark

class RangeSliderGroup extends Component {
  constructor(props) {
    super(props)

    const { markers } = this.props

    initialValues = {}
    marks = {}

    initialValues['min'] = this.props.initialValues[0]
    initialValues['max'] = this.props.initialValues[1]

    this.state = {
      unsure: false
    }

    Object
      .keys(markers)
      .map( (key, index) => {
        let marker = (markers[key]['marker']) ? markers[key]['marker'] : 0
        let label = (markers[key]['label']) ? markers[key]['label'] : '0'
        marks[marker] = label
    })


    let lastMarker = Object.keys(markers).slice(-1)[0]
    lastMark = markers[lastMarker]
    firstMark = markers[0]

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
  }

  handleCheckboxChange(e) {
    const { checked } = e.target
    let unsure
    if(!checked) {
      unsure = false
    } else {
      unsure = true
    }
    this.setState({
      unsure: unsure
    })
    this.props.sliderChange(null, this.state.unsure)
  }

  render() {
    let unsureText = `I'm not sure of my ${this.props.label}`
    return(
      <div>
        <Slider.Range
          min={firstMark['marker']}
          max={lastMark['marker']}
          step={this.props.stepAmmount}
          defaultValue={[initialValues['min'], initialValues['max']]}
          marks={marks}
          onChange={(value) => {this.props.sliderChange(value, this.state.unsure)}}
          allowCross={false}
          pushable={this.props.stepAmmount * 2}
          disabled={ this.state.unsure }
        />
        <Checkbox
          key={ `unsure_${this.props.label}` }
          id={ `unsure_${this.props.label}` }
          name={ `unsure_${this.props.label}` }
          label={ unsureText }
          isChecked={ this.state.unsure }
          onChange={ (e) => this.handleCheckboxChange(e) }
        />
      </div>
    )
  }
}

export default RangeSliderGroup;
